<template lang="pug">
div
  el-form-item(label="默认格式")
    el-select(v-model="activeValue")
      el-option(v-for="item in formats", :key="item.value", v-bind="item")
</template>
<script>
import { mapVFOptions, settingMixin } from "@/CommonDP/VForm/utils";
import { SWITCH_ENUM } from "./index.js";

export default {
  mixins: [settingMixin],
  data() {
    return {
      formats: ["bool", "num", "yn", "tf"].map((k) => {
        const item = SWITCH_ENUM[k];
        return item ? { label: item.join("/"), value: k } : undefined;
      })
    };
  },
  computed: {
    ...mapVFOptions(["activeValue"])
  }
};
</script>
